import * as React from "react";
import LogoIcon from '-!svg-react-loader!./logo.svg';
import "./Logo.scss";

export default function Logo(props) {
  return (
  	<LogoIcon className={`logo ${props.className}`} />
  );
}